import React from "react";
import Layout from "../../layout/layout";
import SEO from "../../components/SEO";

const GiftCards = () => {
	return (
		<>
			<SEO
				title="Gift Cards - Otto Africa"
				description="Discover Otto Africa's digital gift card solutions. Create, manage, and sell gift cards for your business with our comprehensive platform."
				keywords="gift cards, digital gift cards, gift card solutions, Otto Africa gift cards"
				url="https://ottoafrica.com/about/gift-cards"
			/>
			<Layout />
		</>
	);
};

export default GiftCards;
